export const LOGO_WHITE =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_echo-redesign-2/artifacts/6dlstl7l_Transparent%20full.png";

export const IMAGES = {
  coachingHero:
    "https://images.unsplash.com/photo-1573495804658-7885a640fc1c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBjb2FjaGluZyUyMG1lbnRvcnxlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3ODMwMzk0NzF8MA&ixlib=rb-4.1.0&q=85",
  methodology:
    "https://images.unsplash.com/photo-1683208231012-0995e510b219?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  about:
    "https://images.unsplash.com/photo-1573497491208-6b1acb260507?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  echoDevice:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_echo-redesign-2/artifacts/r6x50qnf_Welcome%201.png",
};

export const CONSULT_URL =
  "https://stan.store/teivian/p/book-a-11-coaching-call-with-me-f2jlbk8o";

export const NAV_LINKS = [
  { label: "Methodology", href: "#methodology" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "About", href: "#about" },
  { label: "Echo", href: "#echo" },
  { label: "Contact", href: "#contact" },
];

export const METHODOLOGY = [
  {
    title: "Comprehensive Coaching",
    body: "Unlike other coaching services who tend to focus on one area, we offer an all-rounded programme that encompasses work, personal, mental, and physical health.",
  },
  {
    title: "Mix & Match Program",
    body: "You have the power to choose your own curriculum and map out your journey from our range of online courses, e-guides, and mentorship services.",
  },
  {
    title: "1:1 Consultation",
    body: "Personalised strategies to help you obtain clarity, confidence, and direction — no matter what stage of life you're in.",
  },
];

export const SPOTLIGHT = {
  quote:
    "It was a pleasure working with Teivian. Organized and strategic, he coordinates team efforts effectively and fosters a collaborative environment. His leadership, proactivity, and strong work ethic consistently drive projects toward success \u2014 a driven and warm colleague who genuinely cares about the people he works with. Teivian will be a fantastic asset anywhere he goes!",
  name: "Donna Yip",
};

export const REVIEWS = [
  "/reviews/1.webp",
  "/reviews/2.webp",
  "/reviews/3.webp",
  "/reviews/4.webp",
  "/reviews/5.webp",
  "/reviews/6.webp",
  "/reviews/7.webp",
];

export const TESTIMONIALS = [
  {
    name: "Amara L.",
    role: "Founder",
    quote:
      "Primal Origins didn't just coach me — they rebuilt the way I approach every decision. I finally feel in control of my direction.",
    avatar:
      "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?crop=entropy&cs=srgb&fm=jpg&q=85&w=300",
  },
  {
    name: "Jordan M.",
    role: "Product Lead",
    quote:
      "The methodology is unlike anything else. It bridged my career goals with my personal life in a way that actually stuck.",
    avatar:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&q=85&w=300",
  },
  {
    name: "Sofia R.",
    role: "Consultant",
    quote:
      "Human-first, evidence-based, and genuinely transformative. My sessions gave me clarity I'd been chasing for years.",
    avatar:
      "https://images.unsplash.com/photo-1506863530036-1efeddceb993?crop=entropy&cs=srgb&fm=jpg&q=85&w=300",
  },
  {
    name: "Daniel K.",
    role: "Operations Manager",
    quote:
      "A grounded, no-nonsense approach to growth. I rediscovered my drive and the confidence to act on it.",
    avatar:
      "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&q=85&w=300",
  },
];

export const ECHO_FEATURES = [
  {
    key: "verification",
    title: "Triple-Layer Verification",
    body: "We utilise government-grade identity verification, biometric face matching, and IP screening. No bots, no fakes. Just verified individuals.",
  },
  {
    key: "resonance",
    title: "Calculated Resonance",
    body: "Our proprietary engine uses your birthdate along with other calculations as part of our computational logic to identify natural synergy between users with mathematical precision.",
  },
  {
    key: "accountability",
    title: "High Accountability",
    body: "By removing anonymity and implementing strict entry protocols, we've created a space where digital connections have real-world integrity.",
  },
];

export const COMPANY = {
  legalName: "PRIMAL ORIGINS PTY LTD",
  acn: "697 504 993",
  location: "Melbourne, Australia",
  email: "info@primal-origins.com",
};

export const TERMS = [
  { h: "Effective Date: 1st May 2026" },
  {
    h: "1. Eligibility",
    p: "You must be at least 18 years old to use Echo by Primal Origins. By creating an account, you represent that you have never been convicted of a felony or a sex crime.",
  },
  {
    h: "2. Identity Verification & Accountability",
    p: "To maintain a high-accountability environment, Echo requires mandatory identity verification.",
    li: [
      "Third-Party Verification: Verification is performed by Didit. You agree to provide the necessary biometric and identification data required to authenticate your profile.",
      "Account Access: Failure to complete verification or providing fraudulent information will result in immediate account termination.",
      "Responsibility: While we use Didit to verify \u201chumanity\u201d and reduce bot presence, Primal Origins does not conduct comprehensive criminal background checks. You remain solely responsible for your interactions and safety.",
    ],
  },
  {
    h: "3. Community Standards",
    p: "We maintain a zero-tolerance policy for harassment, hate speech, nudity, or fake profiles. Echo by Primal Origins reserves the right to terminate any account at our sole discretion without a refund.",
  },
  {
    h: "4. Communications",
    p: "By joining the waitlist or creating an account, you consent to receive transactional and account-related emails (such as invitation codes and referral updates) sent via Amazon SES.",
  },
  {
    h: "5. Subscriptions & Billing",
    li: [
      "Payments: Handled exclusively by the Apple App Store or Google Play Store.",
      "Auto-Renewal: Your subscription will automatically renew unless turned off in your phone's Store Settings at least 24 hours before the period ends.",
      "Refunds: Handled by third-party stores; Echo by Primal Origins cannot issue refunds directly.",
    ],
  },
  {
    h: "6. Limitation of Liability & Governing Law",
    li: [
      "Liability: To the maximum extent permitted by Australian law, Echo by Primal Origins is not liable for any damages (physical, emotional, or financial) arising from your use of the app or offline meetings.",
      "Governing Law: These terms are governed by the laws of Victoria, Australia.",
    ],
  },
];

export const PRIVACY = [
  { h: "Effective Date: 1st May 2026" },
  {
    h: "1. Data We Collect",
    li: [
      "Registration: Your name, age, birthdate (for resonance logic), and photos.",
      "Identity Verification: Biometric face matching and government-grade ID data processed via Didit.",
      "Calculated Resonance: Proprietary logic using your data to identify synergy between users.",
      "Referral Data: We track unique referral links and counts to manage waitlist rewards (Professional/Elite tiers).",
    ],
  },
  {
    h: "2. Data Storage & Processing",
    p: "Your data is stored and managed using Base44. This infrastructure ensures your profile and resonance data remain secure and accessible only for the purposes of operating the Echo platform.",
  },
  {
    h: "3. Third-Party Service Providers",
    p: "We share specific data with trusted partners only to provide our services:",
    li: [
      "Didit: For secure biometric identity verification.",
      "Amazon SES: For sending transactional emails and system notifications.",
      "App Stores: Apple and Google handle all payment processing; we do not see or store your credit card details.",
    ],
  },
  {
    h: "4. How Your Data is Used",
    p: "We use your data to facilitate connections and calculate resonance. We do not sell your personal identity or biometric data to third-party marketers.",
  },
  {
    h: "5. Data Retention & Deletion",
    p: "We keep your data as long as your account is active. You can delete your account at any time in the app settings. Once deleted:",
    li: [
      "Your profile is hidden immediately.",
      "Your data is permanently purged from Base44 systems after 30 days.",
    ],
  },
  {
    h: "6. Contact Us",
    p: "For privacy enquiries or data access requests, contact: info@primal-origins.com",
  },
];
